import { apiGet } from 'packages/lib/api/annotations/rest';
import { tasksRespZod, Task } from 'packages/lib/api/annotations/contract/task';
import {
  taskGroupsRespZod,
  TaskGroup,
} from 'packages/lib/api/annotations/contract/task-group';
import { logError } from 'packages/lib/utils/logger';
import { taskStateZod } from 'packages/lib/api/annotations/contract/enums';

export const getTasksByPipeline = async (pipeline: string): Promise<Task[]> => {
  const taskGroups = await apiGet<TaskGroup[]>(
    `/task-groups?pipeline=${pipeline}&partner=None&orderBy=createdAt`,
    taskGroupsRespZod.parse
  );

  const tasks = await Promise.all(
    taskGroups
      .flat()
      .map((taskGroup) =>
        apiGet<Task[]>(
          `/tasks/data?taskGroupToken=${taskGroup.token}`,
          tasksRespZod.parse
        )
      )
  );

  return tasks
    .flat()
    .filter((task) => task.state !== taskStateZod.enum.Done)
    .sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
};

export const getSiblingLidarboxTasks = async (task: Task): Promise<Task[]> => {
  const siblingTasks =
    (await apiGet(
      `/tasks?lidarExtractionToken=${task.lidarExtractionToken}`,
      tasksRespZod.parse
    ).catch(logError)) ?? [];
  return siblingTasks;
};
